import React, { PureComponent } from 'react';
import { Input as InputAnt } from 'antd';
import PropTypes from 'prop-types';

const { TextArea, Group } = InputAnt;

export default class Input extends PureComponent {
  render() {
    if (this.props.type === 'textArea') {
      return (<TextArea {...this.props} />);
    }
    if(this.props.type === 'inputGroup') {
      return (<Group {...this.props} />)
    }
    return (<InputAnt {...this.props} />);
  }
}

Input.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

Input.defaultProps = {
  type: ''
};
